import React from 'react';

import { env, meta } from '~/commons/config';
import useQuery from '~/commons/hooks/useQuery';
import { useHistory, useLocation } from 'react-router-dom';

import _ from 'lodash';
import SubjectTabs from '../../app/components/layout/SubjectTabs.jsx';
import Articles from './Articles.jsx';

const PageAssignments = () => {
  const defaultKey = Object.keys(env.subjects)[0];

  const history = useHistory();
  const { subject: q } = useQuery();
  const loc = useLocation();
  const subject = q || defaultKey;

  meta.set({ title: '閱讀材料' });

  return (
    <div>
      <SubjectTabs
        tabs={_.orderBy(Object.keys(env.subjects).map((key) => ({
          key,
          label: env.subjects[key].zhhk,
          image: `assets/img/${key}.svg`,
          hoverImage: `assets/img/${key}-hover.svg`,
          sort_order: env.subjects[key].sort_order,
        })), ['sort_order'], ['asc'])}

        active={subject}
        onChange={(s) => {
          history.push(`${loc.pathname}?subject=${s}`);
        }}
      />
      <Articles filter={{ subjects: subject }} />
    </div>
  );
};

export default PageAssignments;
